import { UserMissionForm } from './UserMissionForm'
import { withUserMissionForm } from './withUserMissionForm'

const Connected = withUserMissionForm(UserMissionForm)

export { Connected as UserMissionForm }
